import React, { memo } from 'react';
import ReactLoading, { LoadingProps } from 'react-loading';

import styles from 'Components/loading/LoadingComponents.module.scss';

// NOTE: these two types are copied from react-loading as the types aren't exported
// declare interface LoadingProps {
//   color?: string;
//   height?: any;
//   width?: any;
//   delay?: number;
//   type?: LoadingType;
//   className?: string;
// }
// type LoadingType =
//   | 'blank'
//   | 'balls'
//   | 'bars'
//   | 'bubbles'
//   | 'cubes'
//   | 'cylon'
//   | 'spin'
//   | 'spinningBubbles'
//   | 'spokes';

/*
 * Used for setting up a generic react-loading animation
 *
 * Props:
 *   options - an object filled with customization options
 *   which can consist of the following members:
 *
 *       id - custom id as string
 *       delay - appearance delay in ms
 *       width - int or rem as string
 *       height - int or rem as string
 *       color - color in hex
 *       className - custom class
 *       type - animation type (ex: bars, etc.)
 *
 */
type Props = {
  options?: {
    id?: string;
  } & LoadingProps;
};

const LoadingBars: React.FC<React.PropsWithChildren<Props>> = ({ options }) => {
  return (
    <ReactLoading
      className={styles.bars}
      color="#0098ff"
      height="5rem"
      // id="content-loading-bars"
      type="bars"
      width="5rem"
      {...options}
    />
  );
};

export default memo(LoadingBars);
